export function orderStudents(students, savedPosition) {
  const savedIds = typeof savedPosition === 'string'
    ? savedPosition.split(',').map((id) => id.trim()).filter(Boolean)
    : [];
  const positions = new Map(savedIds.map((id, index) => [String(id), index]));

  return [...(Array.isArray(students) ? students : [])].sort((firstStudent, secondStudent) => {
    const firstPosition = positions.has(String(firstStudent.id_eleve))
      ? positions.get(String(firstStudent.id_eleve))
      : Number.MAX_SAFE_INTEGER;
    const secondPosition = positions.has(String(secondStudent.id_eleve))
      ? positions.get(String(secondStudent.id_eleve))
      : Number.MAX_SAFE_INTEGER;

    return firstPosition - secondPosition;
  });
}
